import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { filter, map, startWith } from 'rxjs';
import { StartWhatsappConversation } from '@components/whatsapp-button/whatsapp-button.component';

import { FooterComponent } from '@shared/components/footer/footer.component';
import { NavbarComponent } from '@shared/components/navbar/navbar.component';
import { ToastContainerComponent } from '@shared/components/UI/Toast/toast-container.component';

@Component({
  selector: 'app-shop-layout',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent, FooterComponent, StartWhatsappConversation, ToastContainerComponent],
  templateUrl: './shop-layout.component.html',
})
export class ShopLayoutComponent {
  private readonly router = inject(Router);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.router.url),
      startWith(this.router.url),
    ),
  );

  public readonly isEncargoRoute = computed(() => (this.currentUrl() ?? '').startsWith('/encargo'));
}
